import React, { useRef, } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { AiOutlineQuestionCircle, } from 'react-icons/ai'
import { FaCheck } from 'react-icons/fa'
import '../css/GoodCheck.css'

const styles = {
    container: {
        padding: '0',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center'
    },
    label: {
        width: '70%'
    },
    check: {
        width: '20%'
    },
    help: {
        width: '10%',
        display: 'flex',
        alignItems: 'center'
    }
}

const GoodCheck = ({ 
    defaultChecked = false, 
    onChange = (e) => console.log(e), 
    label = undefined, 
    reset = false, 
    helpTitle = false, 
    checkColor = "#FFF",
    custom_styles = {
        container: {
        },
        label: {
        },
        check: {
        },
        help: {
        }
    }
    }) => {

    const on = useRef(defaultChecked)
    const handleClick = () => {
        on.current = !on.current
        onChange({ target: { value: on.current } })
    }


    return (
        <div style={{...styles.container, ...custom_styles.container}} >
            <div style={styles.label} xs={8} >
                {label && (
                    <p style={{ marginTop: 0, marginBottom: 0 }}>{label}</p>
                )}
            </div>
            <div style={{...styles.check, ...custom_styles.check}} xs={3}>
                {!reset && (
                    <div
                        className={`good-checkbox ${defaultChecked && 'clicked'}`}
                        defaultChecked={defaultChecked}
                        onClick={(e) => { e.preventDefault(); handleClick(e) }}
                    >
                        {defaultChecked ? (
                            <FaCheck color={checkColor} style={{ verticalAlign: 'top' }} size={'14pt'} />
                        ) : (
                            // <AiOutlineClose style={{verticalAlign: 'baseline'}} size={'14pt'} />
                            <></>
                        )}
                    </div>
                )}
            </div>
            {helpTitle && (
                <div style={{...styles.help, ...custom_styles.help}} xs={1} title={helpTitle}>
                    <AiOutlineQuestionCircle />
                </div>
            )}
        </div>
    )
}

export default GoodCheck